// removed by extract-text-webpack-plugin
module.exports = {"root":"oKU4K","collectionButton":"-Vcje","favoriteButton":"_255P_"};